/* eslint-disable import/order */
import React from 'react';
import { issueHierarchyPageResource } from '@jira/admin-pages__issue-types-issue-hierarchy-directory/src/issueHierarchyPageResource.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsIssueHierarchyRedirectRoute } from '@jira/router-routes__admin-pages-issue-types-routes/src/globalSettingsIssueHierarchyRedirectRoute.tsx';
import { ScreenRedirect } from '@jira/platform__routing-screen-redirect/src/ui/ScreenRedirect.tsx';
import { LazyIssueHierarchyDirectory } from './ui/spa/admin-pages/issue-types/issue-hierarchy-directory/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const globalSettingsIssueHierarchyRedirectRouteEntry: Route = createEntry(
	globalSettingsIssueHierarchyRedirectRoute,

	() => ({
		group: 'global-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: () => <ScreenRedirect to="/jira/settings/issues/issue-hierarchy" />,
		isRedirect: true,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			issueHierarchyPageResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyIssueHierarchyDirectory],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
